import { useCallback, useState } from "react";
import { useDevices } from "@/store/devices";
import { useCameraSettings } from "@/modules/cameraSettings/CameraSettingsFlow";
import { useViewerActions } from "viewer/modules/monitoring/MonitoringManager";

type Updater = {
  settingsStore: CSTypes.SettingsStore | null;
  openSettings: (jid: string) => void;
};

export default function useCameraSettingsUpdater(): Updater {
  const [selectedDeviceJid, setSelectedDeviceJid] = useState<string | null>(null);
  const { devices, updatePairedDevice } = useDevices((s) => ({
    devices: s.devices as StoreCameraDevices,
    updatePairedDevice: s.updatePairedDevice
  }));
  const controls = useCameraSettings();
  const { getDetectionZonesPreview } = useViewerActions();
  const openSettings = useCallback(
    (jid: string) => {
      setSelectedDeviceJid(jid);
      controls.open();
    },
    [controls]
  );

  const selectedDevice = selectedDeviceJid ? devices[selectedDeviceJid] : null;

  const settingsStore: CSTypes.SettingsStore | null = selectedDevice
    ? {
        xmppLogin: selectedDevice.jid,
        hasWatermarkSettings: selectedDevice.supportedFeatures?.includes("CAMERA_STATION_VIDEO_OVERLAY"),
        hasDetectionZonesSupport: selectedDevice.supportedFeatures?.includes("SINGLE_MOTION_DETECTION_ZONE"),
        state: {
          color: selectedDevice.color,
          name: selectedDevice.name,
          icon: selectedDevice.icon,
          settings: selectedDevice.settings
        },
        getDetectionZonesPreview: () => getDetectionZonesPreview(selectedDevice.jid),
        update: (setting) => {
          updatePairedDevice({
            jid: selectedDevice.jid,
            ...setting
          });
        }
      }
    : null;

  return { settingsStore, openSettings };
}
